import { render, staticRenderFns } from "./todayvideodetails.vue?vue&type=template&id=f424cd6c&scoped=true&"
import script from "./todayvideodetails.vue?vue&type=script&lang=js&"
export * from "./todayvideodetails.vue?vue&type=script&lang=js&"
import style0 from "./todayvideodetails.vue?vue&type=style&index=0&id=f424cd6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f424cd6c",
  null
  
)

export default component.exports